import React from 'react'
import Box from '../../components/Box'

function Inicial() {
    return (
        <Box/>
    )
}

export default Inicial
